export default "/images/vendor/flag-icons/flags/1x1/py.svg?8894733432ae3d5750514476b77957f0";